import { render, staticRenderFns } from "./AccountTeacher.vue?vue&type=template&id=bced8c6c&"
import script from "./AccountTeacher.vue?vue&type=script&lang=js&"
export * from "./AccountTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports